import { Card, Grid, Link } from "@postenbring/hedwig-react";

import { ImageIllustration } from "../../components/cards/subcomponents/ImageIllustration";

export const Cards = ({ cards, span, color }) => (
    <Grid gap="12-16" span={span} className="hds-mb-20-24">
        {cards.map((card, index) => (
            <Card key={index} variant="slim" color={color}>
                {card.imgUrl && (
                    <ImageIllustration
                        imageUrl={card.imgUrl}
                        imageAltText={card.imgAltText}
                        isIllustration={card.isIllustration}
                        focalPointStyle={card.focalPointStyle}
                    />
                )}
                <Card.Body>
                    {(card.overline || card.title) && (
                        <Card.BodyHeader>
                            {card.overline && (
                                <Card.BodyHeaderOverline>{card.overline}</Card.BodyHeaderOverline>
                            )}
                            {card.title && (
                                <Card.BodyHeaderTitle>{card.title}</Card.BodyHeaderTitle>
                            )}
                        </Card.BodyHeader>
                    )}
                    <Card.BodyDescription>{card.description}</Card.BodyDescription>
                    <Card.BodyAction>
                        <Link
                            href={card.url}
                            variant="solid"
                            target={card.newTab ? "_blank" : "_self"}
                        >
                            <Card.BodyActionArrow direction={card.arrowDirection} />
                            {card.linkText}
                        </Link>
                    </Card.BodyAction>
                </Card.Body>
            </Card>
        ))}
    </Grid>
);
